import { PaymentPricing } from '@/types/payment-account';
import { formatBoletoRange, formatCardBrands, formatFeeLine, formatSettlementLine } from './shared';

/** Perguntas frequentes da tela "Como funciona" (seção 6.2, item 5, com `collapse-reveal`). */
export interface FaqItem {
  question: string;
  answer: (pricing: PaymentPricing) => string;
}

export const PAYMENT_ABOUT_FAQ: FaqItem[] = [
  {
    question: 'Posso voltar ao manual?',
    answer: () =>
      'Sim, quando quiser. Ao desligar, as cobranças em aberto voltam para o Pix copia-e-cola e o link do seu perfil, e o que já está a caminho da sua conta continua caindo normalmente.',
  },
  {
    question: 'E se o cliente pedir o dinheiro de volta?',
    answer: () =>
      'Pix e cartão você devolve pelo próprio app, direto na cobrança. Boleto pago não tem devolução automática: nesse caso você devolve por fora, como hoje.',
  },
  {
    question: 'Meu cliente só tem Elo, e agora?',
    answer: (pricing) =>
      `O checkout aceita cartão ${formatCardBrands(pricing.cardBrands)}. Se o cartão do cliente não passar, ele vê a opção de pagar direto a você, do jeito manual de sempre.`,
  },
  {
    question: 'Dá para parcelar?',
    answer: () => 'Ainda não. Por enquanto, só à vista.',
  },
  {
    question: 'Posso receber em dinheiro às vezes?',
    answer: () =>
      'Pode. Em qualquer cobrança automática dá para tocar em "Confirmar recebimento" quando o cliente pagar direto a você — ela fecha como paga e sai da fila do automático.',
  },
  {
    question: 'Preciso de CNPJ?',
    answer: () =>
      'Não. Você ativa como pessoa física, com o seu CPF, ou como empresa, se preferir.',
  },
  {
    question: 'Quem paga a taxa?',
    answer: (pricing) =>
      `A taxa é descontada do valor que você recebe, na hora do repasse — não é uma cobrança à parte. Hoje: ${formatFeeLine(pricing)}. Você sempre vê o bruto, a taxa e o líquido de cada pagamento.`,
  },
  {
    question: 'E o imposto?',
    answer: () =>
      'Isso não muda: o valor recebido continua sendo sua receita, do mesmo jeito que é hoje no manual. O extrato de repasses serve de apoio para o seu contador.',
  },
  {
    question: 'Posso receber na hora?',
    answer: (pricing) =>
      `Não: no Brasil o repasse sai uma vez por dia. ${formatSettlementLine(pricing)} até o valor ficar disponível, e o repasse para o seu banco sai automaticamente assim que libera.`,
  },
];

/** Bloco fixo usado no artigo "Limites e bandeiras" e reaproveitável na FAQ, se algum dia precisar de mais detalhe. */
export function getAcceptedMethodsSummary(pricing: PaymentPricing): string {
  return `Cartão ${formatCardBrands(pricing.cardBrands)} · boleto ${formatBoletoRange(pricing)}`;
}
